import { z } from 'zod';

export const previewClipTitleV1RequestSchema = z.object({
  title: z.string().min(1),
});

export type IPreviewClipTitleV1Request = z.infer<typeof previewClipTitleV1RequestSchema>;
